import React, { memo, useState } from "react";
import Button from "react-bootstrap/Button";
import { Form } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Priority from "../../../../../../components/priority/priority";
import { selectSelectedTemplateTasks } from "../../../../../../redux/templates-tasks/template-task-selector";
import {
  addSelectedTemplateTasks,
  deleteSelectedTemplateTasks,
  showTemplateSubtask,
} from "../../../../../../redux/templates-tasks/template-task-actions";
import { UploadTemplateTaskAPI } from "../../../../../../services/api/project-template-api";
import "./template-task-row.styles.scss";
import AdminActionsPopupNew from "../../../admin-actions-popup/AdminActionsPopupNew";
import {
  GetPriority,
  GetWorkItemType,
  BrowseFiles,
  UploadFiles,
} from "../../template-task-utility";
import PropTypes from "prop-types";
import { validFileTypes } from "../../../../../../util/file-helpers";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';

const TemplateTasksRowNew = ({
  data,
  privileges,
  templateID,
  templateName,
  isSubtask,
  hasSubtask,
  setAlertConfig,
  refreshPage,
  taskTypes,
}) => {
  const [showAdminActionsPopup, setShowAdminActionsPopup] = useState(false);

  let history = useHistory();
  const dispatch = useDispatch();
  const selectedRows = useSelector(selectSelectedTemplateTasks);

  const onTaskEdit = () => {
    if (!privileges.Templates.Edit === false) {
      history.push({
        pathname: `/admin/templates/tasks/edit/${data.Id}`,
        state: { templateID: templateID, templateName: templateName },
      });
    }
  };

  const onSubtaskEdit = () => {
    if (!privileges.Templates.Edit === false) {
      history.push({
        pathname: `/admin/templates/subtasks/edit/${data.Id}`,
        state: { templateID: templateID, taskID: data.ProjectTypeTaskId },
      });
    }
  };

  // Part of phasing out subtasks
  // const onSubtaskCreate = () => {
  //   if (!privileges.Templates.Add === false) {
  //     history.push({
  //       pathname: `/admin/templates/subtasks/create`,
  //       state: { templateID: templateID, taskID: data.Id },
  //     });
  //   }
  // };

  const onSelect = (e) => {
    if (e.target.checked) {
      dispatch(addSelectedTemplateTasks(data.Id));
    } else {
      dispatch(deleteSelectedTemplateTasks(data.Id));
    }
  };

  const onFileAdd = async (e) => {
    try {
      if (!privileges.Templates.Edit) return;
      let files = BrowseFiles(e, []);
      let fileResult = await UploadFiles(files);
      if (!fileResult) return;
      let task = { Attachments: fileResult.data, Id: data.Id };

      await UploadTemplateTaskAPI(task);
      refreshPage();
    } catch (error) {
      setAlertConfig((prevState) => ({
        ...prevState,
        showAlert: true,
        alertMessage: error.toString(),
      }));
    }
  };

  return (
    <tr className={isSubtask ? "template-subtask-row" : "template-task-row-1"}>
      <td className="th-checkbox-col action-holder">
        {!isSubtask && (
          <div className="action-holder">
            <Form.Check
              type={"checkbox"}
              disabled={!privileges.Templates.Delete}
              onClick={(e) => {
                onSelect(e);
              }}
              checked={selectedRows.includes(data.Id)}
            />
            {hasSubtask && (
              <button
                className="action-button subtask"
                onClick={() => dispatch(showTemplateSubtask(data.Id))}
              ></button>
            )}
          </div>
        )}
      </td>

      <td className="data-text template-task-name">
        {data.Name ? data.Name : ""}
      </td>
      <td className='data-text template-task-description'>
                <OverlayTrigger
                    trigger={['hover', 'focus']}
                    placement="bottom"
                    delay={{ show: 150, hide: 150 }}
                    overlay={
                    <Popover id="description-popover" className="custom-popover">
                        <Popover.Content>
                        {data.Description ? data.Description : ""}
                        </Popover.Content>
                    </Popover>
                    }
                >
                    <div className="text-wrapper">
                    <span className="text-content">{data.Description ? data.Description : ""}</span>
                    </div>
                </OverlayTrigger>
            </td>

      <td className="data-text template-task-priority">
        <div className="priority-icon">
          <Priority priority={GetPriority(data?.Priority) || "Low"} />
        </div>
      </td>
      <td className="data-text template-task-work-type">
        {GetWorkItemType(data?.WorkItemTypeId, taskTypes)}
      </td>

      {/* 
      // Part of phasing out subtasks
      <td className="data-text template-task-subtasks">
        {hasSubtask ? data.SubTasks.length : 0}
        <Button
          className="template-task-number"
          onClick={onSubtaskCreate}
          disabled={isSubtask || !privileges.Templates.Add}
        />
      </td> */}
      <td className="data-text template-task-attachment">
        {data.AttachmentCount ? data.AttachmentCount : 0}
        <Button
          className="template-task-number"
          disabled={!privileges.Templates.Edit}
        >
          <input
            type="file"
            accept={validFileTypes.join(",")}
            multiple
            className="template-task-file-selection"
            onChange={onFileAdd}
            disabled={!privileges.Templates.Edit}
          />
        </Button>
      </td>

      <td className="admin-row-action-buttons">
        <Button
          className={`btn-icon1 btn-icon-edit ${
            !privileges.Templates.Edit === false
              ? "edit-icon1"
              : "edit-icon1-disabled"
          }`}
          disabled={!privileges.Templates.Edit}
          onClick={() => (isSubtask ? onSubtaskEdit() : onTaskEdit())}
          title="Edit"
        />
      </td>

      {showAdminActionsPopup && (
        <AdminActionsPopupNew
          type={"task"}
          name={data.Name}
          selectedIDs={[data.Id]}
          showAdminActionsPopup={showAdminActionsPopup}
          setShowAdminActionsPopup={setShowAdminActionsPopup}
        />
      )}
    </tr>
  );
};
TemplateTasksRowNew.propTypes = {
  data: PropTypes.object.isRequired,
  privileges: PropTypes.object.isRequired,
  templateID: PropTypes.number.isRequired,
  templateName: PropTypes.string.isRequired,
  isSubtask: PropTypes.bool,
  hasSubtask: PropTypes.bool.isRequired,
  setAlertConfig: PropTypes.func.isRequired,
  refreshPage: PropTypes.func.isRequired,
  taskTypes: PropTypes.array,
};
export default memo(TemplateTasksRowNew);
